export default "../css/48547f6b5e9d66443e3f842885241f7b.ttf";